import { useEffect, useState } from "react";
import axiosInstance from "../Axios";
import { toast } from "sonner";
import { Link } from "react-router-dom";
import Button from "@mui/material/Button";
import { useParams } from "react-router-dom";
import { BeatLoader } from "react-spinners";
import useAuth from "../contexts/UserContext.tsx";

export default function IndvidualMathlabUsers() {
  const [studentsData, setStudentsData] = useState([]);
  const { id } = useParams();
  const { user, logout } = useAuth();
  const [baseURL, setBaseURL] = useState("");

  const getUsers = async () => {
    axiosInstance
      .get(`getMathLabUsers?school_id=${id}&auth_token=${user.auth_token}`)
      .then((res) => {
        if (res.data.data.message === "Invalid User") {
          toast.error("Invalid User");
          logout();
          return;
        }
        setStudentsData(res.data.data.data);
      })
      .catch((err) => {
        toast.error(err);
      });
  };

  useEffect(() => {
    if (user.view_access_list.smartclass && user.view_access_list.mathlab) {
      setBaseURL("dashboard");
    } else {
      setBaseURL("mathlab");
    }
    getUsers();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="container mt-5">
      <div className="row justify-content-center">
        <div className="col-md-10">
          <div className="card">
            <div className="card-header">
              <h3>
                <b>Mathlab Users</b>
              </h3>
            </div>
            {/* Add Filter based on District, school_type and school */}

            <div className="card-body max-h-[30rem] overflow-y-scroll">
              <div className="table-responsive">
                <table className="table table-striped h-20">
                  <thead>
                    <tr>
                      <th>First Name</th>
                      <th>Last Name</th>
                      <th>Roll Number</th>
                      <th>Current Grade</th>
                      <th>Cell Number</th>
                      <th>User Name</th>
                    </tr>
                  </thead>
                  <tbody id="userList" className="overflow-y-scroll">
                    {/* User data will be dynamically inserted here */}
                    {studentsData.length === 0 && (
                      <tr>
                        <td colSpan="6">
                          <div
                            className="alert flex justify-center"
                            role="alert"
                          >
                            <BeatLoader loading={true} color="#4CAF50" />
                          </div>
                        </td>
                      </tr>
                    )}
                    {studentsData &&
                      studentsData.map((student, index) => {
                        return (
                          <tr key={index}>
                            <td>{student.fname}</td>
                            <td>{student.lname}</td>
                            <td>{student.roll_number}</td>
                            <td>{student.current_grade}</td>
                            <td>{student.cell_num}</td>
                            <td>{student.user_name}</td>
                          </tr>
                        );
                      })}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="flex justify-center mt-2">
        <Button
          variant="contained"
          sx={{
            backgroundColor: "#4CAF50",
            color: "white",
            "&:hover": {
              backgroundColor: "#45a049",
            },
          }}
        >
          <Link
            style={{ textDecoration: "none" }}
            to={`/${baseURL}/school/${id}/add-mathlab-user`}
            className="hover:text-white font-medium"
          >
            Add new user
          </Link>
        </Button>
      </div>
    </div>
  );
}
